import { storage } from "components/common";

const SCOREBOARD_TEMPLATE_STORAGE_KEY = "scoreboardTemplate";

const [fetchScoreboardTemplate, storeScoreboardTemplate] = storage(SCOREBOARD_TEMPLATE_STORAGE_KEY, {
  defaultValue: "",
});

export default { fetchScoreboardTemplate, storeScoreboardTemplate };
